export default "__VITE_ASSET__CRmIfEV2__"